import React, { useContext, useState, useEffect } from 'react'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import ValuePoint from 'admin/components/ValuePoint'
import HelpIcon from '@mui/icons-material/Help'
import {
  Card,
  Grid,
  Typography,
  Box,
  Button,
  Collapse,
  Tooltip,
  Fade,
  IconButton,
} from '@mui/material'
import { ExpandMore } from '@mui/icons-material'

const dollarCentsFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

function Deductions({
  collapseSections,
  toggleCollapse,
  deductions,
  cashAddbackTotals,
  intakeState,
  updateIntakeStateAtKey,
  updateIntakeStateAndSubmit,
}) {
  const isGovernmentEmployee = intakeState?.governmentEmployee
  const [localForm, setLocalForm] = useState({
    netTakeHome: intakeState.netTakeHome || '',
  })
  const handleChange = (field) => (value) => {
    setLocalForm((prev) => ({ ...prev, [field]: value }))
  }
  const monthlyCashAddbackTotal =
    cashAddbackTotals?.working > 0 ? cashAddbackTotals.working : 0
  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse
                in={collapseSections.deductions}
                style={{ width: '100%' }}
              >
                {deductions.some((obj) => obj.subType === 'fsa') && (
                  <ValuePoint
                    text="FSA - Draining Before Separation Date"
                    type="warning"
                  />
                )}
                {deductions.some((obj) => obj.subType.startsWith('alot')) && (
                  <ValuePoint
                    text="ALOT - verify if it is used for regular expenses"
                    type="warning"
                  />
                )}
                <ValuePoint
                  text={`Monthly Net Take Home: ${
                    intakeState?.netTakeHome
                      ? dollarCentsFormat.format(
                          ((intakeState?.netTakeHome / 80) * 2087) / 12 || 0
                        )
                      : 'Need Net Take Home'
                  }`}
                  type="data"
                />
              </Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="deductions"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('deductions')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                {isGovernmentEmployee ? 'Deductions & Net Pay' : 'Net Pay'}
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.deductions
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse in={collapseSections.deductions} style={{ width: '100%' }}>
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              {isGovernmentEmployee && (
                <Grid
                  item
                  xs={12}
                  sx={{ '& .assetTitleDateBox': { width: '60%' } }}
                >
                  {renderMuiFormField({
                    inputType: 'deductionsReview',
                  })}
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  id: 'netTakeHome',
                  label: (
                    <>
                      <span>
                        Net take home per pay period
                        <span style={{ color: 'red' }}> *</span>
                        <Tooltip
                          TransitionComponent={Fade}
                          title="How much you take home in a normal pay period net of all deductions"
                          placement="top"
                          color="info"
                        >
                          <IconButton size="small" color="dark">
                            <HelpIcon sx={{ marginTop: '-6px' }} />
                          </IconButton>
                        </Tooltip>
                      </span>
                    </>
                  ),
                  placeholder: '$3,500',
                  inputType: 'currencyFloat',
                  value: localForm.netTakeHome,
                  onChange: (e) => handleChange('netTakeHome')(e),
                  onBlur: updateIntakeStateAndSubmit((netTakeHome) =>
                    updateIntakeStateAtKey({ netTakeHome })
                  ),
                })}
                <Typography variant="inputNote" component="p">
                  Net Take Home Monthly:{' '}
                  {dollarCentsFormat.format(
                    ((intakeState?.netTakeHome / 80) * 2087) / 12 || 0
                  )}
                </Typography>
                <Typography variant="inputNote" component="p">
                  Net Take Home Monthly w/ Cash Addbacks:{' '}
                  {dollarCentsFormat.format(
                    (((intakeState?.netTakeHome / 80) * 2087) / 12 || 0) +
                      monthlyCashAddbackTotal
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default Deductions
